/**
 * Single place for reading persisted auth payload and deriving access-token lifetime.
 */

export function readStoredAuthInfo() {
  try {
    const raw = localStorage.getItem("authInfo");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** When API returns expiresIn (seconds relative to issuance), persist absolute cutoff. */
export function withExpiresFromPayload(authLike) {
  if (!authLike || typeof authLike !== "object") return authLike;
  const expiresIn = authLike.expiresIn;
  if (expiresIn == null || !Number.isFinite(Number(expiresIn))) {
    return authLike;
  }
  const ms = Number(expiresIn) * 1000;
  return {
    ...authLike,
    expiresAtMs: Date.now() + ms,
  };
}

const CLOCK_SKEW_MS = 30_000;

/**
 * True when past known expiry. Missing expiresAtMs (legacy sessions) is treated as fresh;
 * those sessions rely on 401 + interceptor refresh until the next login persists expiresAtMs.
 */
export function isAccessTokenStale(auth) {
  if (!auth?.accessToken) return true;
  if (auth.expiresAtMs == null) return false;
  return Date.now() >= Number(auth.expiresAtMs) - CLOCK_SKEW_MS;
}
